const ColorIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M12.5 2C7.53 2 3.5 6.03 3.5 11C3.5 15.97 7.53 20 12.5 20H14.5C15.88 20 17 18.88 17 17.5C17 16.12 15.88 15 14.5 15H12.5C10.29 15 8.5 13.21 8.5 11C8.5 8.79 10.29 7 12.5 7H15.5C17.43 7 19 8.57 19 10.5V11C21.43 11 23.5 8.93 23.5 6.5C23.5 3.46 20.54 2 18.5 2H12.5Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="8.5" cy="6.5" r="1.5" fill="#FF5F5F" />
        <circle cx="6.5" cy="10.5" r="1.5" fill="#5F85FF" />
        <circle cx="9.5" cy="14.5" r="1.5" fill="#4CAF50" />
        <circle cx="13.5" cy="6.5" r="1.5" fill="#FFC107" />
      </svg>
    </div>
  );
};

export default ColorIcon;
